import { EventDispatcher } from './EventDispatcher';

export default class SliderVideoController {
    constructor(selector, thresholdtype) {
        this.selector = selector;
        this.options = {
            threshold: thresholdtype === 'desktop' ? 0.5 : 0.7,
        };

        this.observer = null;
        this.videos = [];

        EventDispatcher.on('pageTransition', this.handlePageTransition.bind(this));
    }

    handlePageTransition(e) {
        if (e.detail.namespace === 'enter' || e.detail.namespace === 'once') {
            const container = e.detail.container;
            if (!container) return;

            this.pauseAllVideos();

            const videos = container.querySelectorAll(this.selector);
            if (videos.length > 0) {
                this.initializeObserver(videos);
            }
        } else if (e.detail.namespace === 'leave') {
            this.disconnectObserver();
        }
    }

    initializeObserver(videos) {
        if (this.observer) this.disconnectObserver();

        this.videos = Array.from(videos);
        this.videos.forEach((video, index) => {
            video.dataset.index = index;
            video.pause();
            const slide = video.closest('.slider-info-video');
            if (slide) slide.style.opacity = 0;
            video.dataset.loaded = video.dataset.loaded || 'false';
        });

        let preloaded = false;

        this.observer = new IntersectionObserver((entries) => {
            if (preloaded) return;

            const anyVisible = entries.some((entry) => entry.isIntersecting);
            if (anyVisible) {
                this.preloadAllVideos();
                preloaded = true;

                this.disconnectObserver();
            }
        }, this.options);

        this.videos.forEach((video) => this.observer.observe(video));
    }

    preloadAllVideos() {
        this.videos.forEach((video) => {
            if (video.dataset.loaded === 'true') return;

            const source = video.querySelector('source');
            if (source && source.dataset.src) {
                video.src = source.dataset.src;
                video.load();

                video.addEventListener(
                    'loadeddata',
                    () => {
                        video.dataset.ready = 'true';
                        video.dataset.loaded = 'true';
                    },
                    { once: true }
                );
            }
        });
    }

    pauseAllVideos() {
        this.videos.forEach((video) => {
            if (!video.paused) {
                video.pause();
            }
        });
    }

    disconnectObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        this.videos = [];
    }
}
